import { Button, Stack } from "@mui/material";
import { useContext, useState } from "react";
import ConfigContext from "../../../context/ConfigContext";
import { z } from "zod";
import { hasFormChanged, zodSubmit } from "../../../utils/FormUtils";
import DisabledWrapper from "../../../components/DisabledWrapper";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import ImageUpload from "../../../components/ImageUpload";

// Zod schema
const getSchema = (MAX_IMG_SIZE) =>
    z.object({
        profile_picture: z
            .any()
            .refine(
                (file) => (!!file && file.size <= MAX_IMG_SIZE*1024*1024),
                `A kép mérete nem lehet nagyobb, mint ${MAX_IMG_SIZE} MB`
            )
            .refine(
                (file) =>
                    !file ||
                    ["image/jpeg", "image/png", "image/webp", "image/heic"].includes(file.type),
                "Csak JPG, PNG vagy WEBP formátum engedélyezett"
            )
            .optional(),
    });

const ProfilePicture = ({ data, handleSubmit }) => {
    const { MAX_IMG_SIZE } = useContext(ConfigContext);
    const [errors, setErrors] = useState({});
    const [isDirty, setIsDirty] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);

    const schema = getSchema(MAX_IMG_SIZE);

    return (
        <form
            onSubmit={(e) =>setIsDirty(!zodSubmit(e, setErrors, handleSubmit, schema))}
            onChange={(e) => setIsDirty(hasFormChanged(e.currentTarget, data))}
        >
            <Stack spacing={1} marginTop={2} marginBottom={2}>
                <ImageUpload
                    initialUrl={data?.profile_picture}
                    name="profile_picture"
                    onFileSelect={(file) => setSelectedFile(file)}
                    error={!!errors.profile_picture}
                    helperText={errors.profile_picture}
                />
                <DisabledWrapper
                    disabledCause={[
                        {
                            disabled: !isDirty,
                            message: "Módosítsd a mezőket a mentéshez!",
                        },
                    ]}
                >
                    <Button
                        endIcon={<SaveRoundedIcon />}
                        type="submit"
                        variant="contained"
                    >
                        Módosítások mentése
                    </Button>
                </DisabledWrapper>
            </Stack>
        </form>
    );
};

export default ProfilePicture;
